var _radialGradient, _linearGradient, _radialGradient2, _linearGradient2, _radialGradient3, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft365(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -9.2 960 1074.5000000000002",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2215,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 322,
    cy: 207.3,
    gradientUnits: "userSpaceOnUse",
    r: 800.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#ae7fe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 324.3,
    x2: 210,
    y1: 860.8,
    y2: 663.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 154.3,
    cy: 824.4,
    gradientUnits: "userSpaceOnUse",
    r: 745.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#d59dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e438f"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 872.6,
    x2: 750.1,
    y1: 561,
    y2: 736.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#493474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c66ba",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 889.3,
    cy: 588.1,
    gradientUnits: "userSpaceOnUse",
    r: 598.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#50e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436dcd"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 311.4,
    x2: 491.7,
    y1: 25.4,
    y2: 25.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436dcd",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386 24.6l-5.4 3.3c-8.5 5.2-16.6 11-24.2 17.3L372 34.3h132L528 216 408 336l-120 83.4v96.2c0 67.2 35.1 129.5 92.6 164.2l126.3 76.5L240 912h-51.5l-95.9-58.1C35.1 819.1 0 756.9 0 689.7V366.3C0 299.1 35.1 236.7 92.6 202l288-174.2q2.7-1.7 5.4-3.2z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386 24.6l-5.4 3.3c-8.5 5.2-16.6 11-24.2 17.3L372 34.3h132L528 216 408 336l-120 83.4v96.2c0 67.2 35.1 129.5 92.6 164.2l126.3 76.5L240 912h-51.5l-95.9-58.1C35.1 819.1 0 756.9 0 689.7V366.3C0 299.1 35.1 236.7 92.6 202l288-174.2q2.7-1.7 5.4-3.2z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M936 576l24 36v77.7c0 67.1-35.1 129.4-92.6 164.2l-288 174.4c-61.1 37-137.7 37-198.8 0L99.3 858c59.9 33.1 133.2 31.8 192.1-3.9l288-174.3C636.9 645 672 582.7 672 515.5V408z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M936 576l24 36v77.7c0 67.1-35.1 129.4-92.6 164.2l-288 174.4c-61.1 37-137.7 37-198.8 0L99.3 858c59.9 33.1 133.2 31.8 192.1-3.9l288-174.3C636.9 645 672 582.7 672 515.5V408z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M960 366.3v323.4q0 3.1-.1 6.3c-2.1-64.8-36.8-124.3-92.5-158l-288-174.2c-61.1-37-137.7-37-198.8 0l-92.6 56V192.2c0-67.2 35.1-129.5 92.6-164.3l5.7-3.5C446.5-9.2 520.2-8 579.4 27.8l288 174.2c57.5 34.7 92.6 97.1 92.6 164.3z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M960 366.3v323.4q0 3.1-.1 6.3c-2.1-64.8-36.8-124.3-92.5-158l-288-174.2c-61.1-37-137.7-37-198.8 0l-92.6 56V192.2c0-67.2 35.1-129.5 92.6-164.3l5.7-3.5C446.5-9.2 520.2-8 579.4 27.8l288 174.2c57.5 34.7 92.6 97.1 92.6 164.3z",
    fill: "url(#f)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft365);
export default __webpack_public_path__ + "static/media/Microsoft-365.33b90f959b39d8fdfb30953a334db54a.svg";
export { ForwardRef as ReactComponent };